import { render, staticRenderFns } from "./PayoutRequestCategory.vue?vue&type=template&id=b0797460&"
import script from "./PayoutRequestCategory.vue?vue&type=script&lang=js&"
export * from "./PayoutRequestCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports